export enum CompanyUrls {
    privacyPolicyUrl= '', 
    termsOfUseUrl= '', 
    ratesAndTermsUrl= ''
}

export enum CompanyAssets {
    sunbitPartnerSupportEmail = 'partners@sunbit.com'
}